import { FaSquareGithub } from "react-icons/fa6"
import { FaSquareYoutube } from "react-icons/fa6"
import { SiNexusmods } from "react-icons/si"

export const links = [
    {id:1, link: '#', title: 'Home'},
    {id:2, link: '#about', title: 'About'},
    {id:3, link: '#skills', title: 'Skills'},
    {id:4, link: '#portfolio', title: 'Portfolio'},
    {id:5, link: '#contact', title: 'Contact'},
]

export const socials = [
    {id: 1, link: "https://github.com/thomasfrer", icon: <FaSquareGithub />},
    {id: 2, link: "https://www.youtube.com/@tornas0322", icon: <FaSquareYoutube />},
    {id: 3, link: "https://next.nexusmods.com/profile/Tornastho/mods", icon: <SiNexusmods />}
]
